<template>
  <div class="distributor-box">
    <Alert type="warning" show-icon class="font-size-13">
      {{ $t('key1005589') }}<br/>
      {{ $t('key1005590') }}
    </Alert>
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1005588')" prop="name">
              <Input v-model.trim="pageParams.name" :placeholder="$t('key1000324')" clearable></Input>
            </FormItem>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation-box">
      <!--创建制造商-->
      <Button class="mr15" type="primary" v-if="getPermission('ymsManufacturerInfo_createManufacturer')"
        @click="$refs['manufacturerInfo'].initManufacturerInfoData('add')">
        {{ $t('key1005555') }}
      </Button>
      <!--批量删除-->
      <Button class="mr15" type="primary" v-if="getPermission('ymsManufacturerInfo_deleteMenuFacture')"
        @click="deleteManufacturer('all')">{{ $t('key1002406') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--制造商抽屉-->
    <manufacturerInfoDrawer ref="manufacturerInfo" @updateData="pageParamsStatus = true"></manufacturerInfoDrawer>
    <!--关联商品弹窗-->
    <relatedProductsModal ref="relatedProducts" :responsibleAreaList="responsibleAreaList"></relatedProductsModal>
    <!--关联商品抽屉-->
    <relatedProductsDrawer
      @updateData="pageParamsStatus = true"
      :responsibleAreaList="responsibleAreaList"
      ref="relatedProductsDrawer">
    </relatedProductsDrawer>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {commonLocalStorage, getAllUsersInfo, getCountryZoneData, getUserNameByUserId} from "@/utils/common";
import manufacturerInfoDrawer from "@/views/distributor/components/complianceInfoManage/manufacturerInfoDrawer.vue";
import relatedProductsModal from "@/views/distributor/components/complianceInfoManage/relatedProductsModal.vue";
import relatedProductsDrawer from "@/views/distributor/components/complianceInfoManage/relatedProductsDrawer.vue";

export default {
  name: 'manufacturerInfoList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        name: '',
        pageNum: 1,
        pageSize: 15
      },
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005583'),
          key: 'name',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005584'),
          key: 'relatedProducts',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let manufacturerProductCount = params.row.manufacturerProductCount;
            let ymsManufacturerInfoId = params.row.ymsManufacturerInfoId;
            return h('Alink', {
              props: {
                linkName: manufacturerProductCount,
                textAlign: 'center',
                className: 'justify-content-center',
                AlinkShow: true
              },
              on: {
                AlinkBtn: () => {
                  v.$refs['relatedProducts'].initRelatedProductsData('manufacturer', ymsManufacturerInfoId);
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          align: 'center',
          minWidth: 170,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          key: 'createdBy',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 210,
          render: (h, params) => {
            let ymsManufacturerInfoId = params.row.ymsManufacturerInfoId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002184'),
                    show: v.getPermission('ymsManufacturerInfo_updateManufacturer'),
                    clickFn: () => {
                      v.$refs['manufacturerInfo'].initManufacturerInfoData('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005584'),
                    show: v.getPermission('ymsManufacturerInfo_insertManufacturerProduct'),
                    clickFn: () => {
                      v.$refs['relatedProductsDrawer'].initRelatedProductsDrawerData('manufacturer', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.getPermission('ymsManufacturerInfo_deleteMenuFacture'),
                    clickFn: () => {
                      v.deleteManufacturer('single', ymsManufacturerInfoId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      total: 0,
      responsibleAreaList: [],
      selectTableData: [],
      userInfoList:{}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
        });
        await getCountryZoneData().then((data) => {
          this.responsibleAreaList = data;
        });
        this.search();
      })();
    },
    // 重置按钮
    reset() {
      let v = this;
      if (v.$refs['pageParams']) {
        v.$refs['pageParams'].resetFields();
      }
      v.getList();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.total = 0;
      v.optionBtnWidth = [];
      v.tableData = [];
      if (v.getPermission('ymsManufacturerInfo_getManufacturerList')) {
        v.axios.post(api.post_ymsManufacturerInfo_getManufacturerList, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.tableLoading = false;
            }
            setTimeout(() => {
              let value = commonLocalStorage.getItem('autoCreate') || '';
              if (value) {
                v.$nextTick(() => {
                  if (v.$refs['manufacturerInfo']) {
                    v.$refs['manufacturerInfo'].initManufacturerInfoData('add');
                  }
                });
              }
              commonLocalStorage.removeItem('autoCreate');
            }, 2000);
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data;
      }
    },
    // 删除制造商
    deleteManufacturer(type, ymsManufacturerInfoId) {
      let v = this;
      let content = '';
      let ymsManufacturerInfoIds = [];
      if (type === 'single') {
        ymsManufacturerInfoIds = [ymsManufacturerInfoId];
        content = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005585');
      } else {
        if (v.selectTableData.length > 0) {
          content = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005581')}<span class="distributorThemeColor ml2 mr2">${v.selectTableData.length}</span>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005582')}`;
          ymsManufacturerInfoIds = v.selectTableData.map((item) => {
            return item.ymsManufacturerInfoId;
          });
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005586'));
          return false;
        }
      }
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002162'),
        content: content,
        dangerouslyUseHTMLString: true,
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005587'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.post(api.post_ymsManufacturerInfo_deleteMenuFacture, ymsManufacturerInfoIds,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.selectTableData = [];
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000779'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {

        }
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
  },
  components: {
    relatedProductsDrawer,
    relatedProductsModal,
    manufacturerInfoDrawer
  }
};
</script>

<style lang="less">

</style>
